module.exports = __webpack_public_path__ + "static/media/Group 8460.078a4e40.svg";